import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "comparison-data-controls" }

import { storeToRefs } from "pinia";
import { useTempoStore } from "@/stores/app";


export default /*@__PURE__*/_defineComponent({
  __name: 'ComparisonDataControls',
  setup(__props) {

const store = useTempoStore();
const {
  maps,
  showFieldOfRegard,
  showAdvancedLayers,
  showRGBMode,
  accentColor2
} = storeToRefs(store);

return (_ctx: any,_cache: any) => {
  const _component_layer_order_control = _resolveComponent("layer-order-control")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_power_plants_filter_control = _resolveComponent("power-plants-filter-control")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "my-3" }, " Choose other datasets to view with the TEMPO Data. Drag cards to re-order data layers. ", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(maps), (map, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createVNode(_component_layer_order_control, {
          mapRef: map,
          order: ['power-plants-layer', 'aqi-layer-aqi', 'pop-dens', 'land-use','hms-fire', 'tempo-o3', 'tempo-hcho', 'tempo-no2', 'stamen-toner-lines']
        }, null, 8, ["mapRef"]),
        _createVNode(_component_v_btn, {
          class: "my-2 d-block mx-auto",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showAdvancedLayers.value = !_unref(showAdvancedLayers))),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (showAdvancedLayers.value = !_unref(showAdvancedLayers)), ["enter"])),
          text: _unref(showAdvancedLayers) ? 'Show me less' : 'Show me more!',
          density: "default",
          "hide-details": "",
          color: _unref(accentColor2)
        }, null, 8, ["text", "color"]),
        _createVNode(_component_v_checkbox, {
          modelValue: _unref(showRGBMode),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showRGBMode) ? (showRGBMode).value = $event : null)),
          label: "Use single-color TEMPO layers",
          density: "compact",
          "hide-details": ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_checkbox, {
          modelValue: _unref(showFieldOfRegard),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(showFieldOfRegard) ? (showFieldOfRegard).value = $event : null)),
          label: "Show TEMPO field of regard",
          density: "compact",
          "hide-details": ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_power_plants_filter_control, {
          map: map,
          "layer-id": "power-plants-heatmap"
        }, null, 8, ["map"])
      ]))
    }), 128))
  ]))
}
}

})